import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { getMyPayoutMethods } from "../../services/financialService";
import { ApiArrayResponseModel } from "../community/models/ApiResponseModel";
import { BeneficiaryModel } from "./models/BeneficiaryModel";

export const useBeneficiary = (profit: boolean, hostId?: number, reloadOnNullHost: boolean = true) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<BeneficiaryModel[]>([]);
    const filtered = useMemo(() => {
        return list.filter(l => profit ? l.typeId === 'Commercial' : l.typeId !== 'Commercial' );
    }, [list, profit])

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);


    const load = useCallback(async () => {
        if(!reloadOnNullHost && typeof hostId !== 'number')
            return;
        try {

            const _data: ApiArrayResponseModel<BeneficiaryModel> = await getMyPayoutMethods({offset: 0, limit: 100, host: hostId});
            if(!isMountedRef.current)
                return;
            setList(_data.results);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(true);
        }
    }, [hostId]);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, filtered, reload: load }
}   